import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMessageSquare, FiTrendingUp } = FiIcons;

export default function SectionQuotes({ understandTitle, understandText, alexTitle, alexText }) {
  return (
    <div className="space-y-10">
      {/* Formal Quote from Alex */}
      <div className="bg-white rounded-4xl p-10 md:p-14 shadow-apple border border-gray-100 relative overflow-hidden transition-all duration-300 hover:shadow-apple-hover">
        <div className="absolute top-0 right-0 -mt-8 -mr-8 opacity-5">
          <SafeIcon icon={FiTrendingUp} className="w-64 h-64 text-mutedBlue" />
        </div>
        <div className="relative z-10">
          <h3 className="text-2xl font-semibold mb-6 text-mutedBlue">
            {understandTitle}
          </h3>
          <blockquote className="text-2xl md:text-3xl font-light leading-relaxed text-deepNavy">
            "{understandText.replace(/^"|"$/g, '')}"
          </blockquote>
        </div>
      </div>

      {/* "Just Between Us" Blockquote - Styled distinctly as requested */}
      <div className="border-l-4 border-sage bg-sage-light rounded-r-3xl p-8 md:p-12 shadow-apple-sm">
        <div className="flex items-center mb-6 text-sage-alt">
          <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center mr-4 shadow-sm">
            <SafeIcon icon={FiMessageSquare} className="w-5 h-5 text-sage" />
          </div>
          <h3 className="text-xl font-semibold text-deepNavy">
            {alexTitle}
          </h3>
        </div>
        <blockquote className="text-xl text-deepNavy-light leading-relaxed italic font-light">
          "{alexText.replace(/^"|"$/g, '')}"
        </blockquote>
      </div>
    </div>
  );
}